import React, { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { noResults as noResultsImage } from '@atlassian/company-hub-common/assets';

import { CARDS_EXTENSION_ANALYTIC_SOURCE, CARDS_EXTENSION_TYPE } from '../../../../../constants';
import { ErrorState } from '../error-state';
import type { CommonCardErrorStateProps } from '../index';
import { SmallCardErrorState } from '../small-card-error-state';

import { messages } from './messages';

export type NoResultsErrorStateProps = CommonCardErrorStateProps;

export const NoResults = ({
	cardId,
	cardSize,
	cardHeight,
	isInViewMode,
	errorStatus,
}: NoResultsErrorStateProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		createAnalyticsEvent({
			type: 'sendOperationalEvent',
			data: {
				source: CARDS_EXTENSION_ANALYTIC_SOURCE,
				action: 'error',
				actionSubject: 'noResult',
				attributes: {
					extensionType: CARDS_EXTENSION_TYPE,
					error: errorStatus,
					isInViewMode,
				},
			},
		}).fire();
	}, [createAnalyticsEvent, errorStatus, isInViewMode]);

	switch (cardSize) {
		case 'small':
			return (
				<SmallCardErrorState
					itemId={cardId}
					image={noResultsImage}
					heading={messages.noResults}
					height={cardHeight}
					isInViewMode={isInViewMode}
				/>
			);
		default:
			return (
				<ErrorState
					itemId={cardId}
					heading={messages.noResults}
					description={messages.noResultsDescription}
					image={noResultsImage}
					itemHeight={cardHeight}
					isInViewMode={isInViewMode}
				/>
			);
	}
};
